<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;" class="mater1">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields" foot-clone>
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <!--				<template v-slot:cell(materialData)="data" style="'left':' 80px';">-->
        <!--				        {{ data.item.materialName }}/{{ data.item.materialModel }}/{{ data.item.materialUnit }}-->
        <!--				    </template>-->
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'materialData' ? '140px' : field.key === 'index' ?'30px':'100px',left: field.key === 'materialData' ? '120px' : '80px'}"
          />
        </template>
        <template v-slot:foot()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
        </template>
        <template v-slot:foot(index)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
        </template>
        <template v-slot:foot(totalPriceWithTax)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'totalPriceWithTax') }}</div>
        </template>
        <template v-slot:foot(amountTotal)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'amountTotal') }}</div>
        </template>
        <template v-slot:foot(taxAmount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'taxAmount') }}</div>
        </template>
      </b-table>
      <!-- <div>{{items}}</div> -->
    </div>
  </div>
</template>

<script>


import {Decimal} from "decimal.js";

export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'invoiceTypeCode', stickyColumn: true, label: '发票类别代码'},
        {key: 'invoiceCode', label: '发票编码'},
        {key: 'makeInvoiceSupplierName', label: '开票单位'},
        {key: 'invoiceTypeName', label: '发票类型'},
        {key: 'totalPriceWithTax', label: '含税金额(元)'},
        {key: 'amountTotal', label: '不含税金额(元)'},
        {key: 'taxAmount', label: '税额(元)'},
        {key: 'makeInvoiceTime', label: '开票日期'},
      ],
      items: [],
      dataList: [],
      businessId: '',
      wareNumerLabel: '',
      searchForm: {
        deratedId: ''
      },
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        orders: []
      },
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data
    });
  },
  methods: {
    init() {
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

